import { render, staticRenderFns } from "./PelletFeedingEdit.vue?vue&type=template&id=0540a21f&"
import script from "./PelletFeedingEdit.vue?vue&type=script&lang=js&"
export * from "./PelletFeedingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports